import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import '../../../src/styles/healthInfo.css';
// import Device from './Device';
import { listDevices } from '../../redux/actions/deviceActions';
// import CustomTooltipDevice from '../tooltips/CustomTooltipDevice';
import Mute from '../../images/Mute.png';
import { optEmailCamera } from '../../redux/actions/optEmailCamera';
import { canAccess } from '../../config';
import bin from '../../images/bin.png';
// import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { deleteOfflineCamera } from '../../redux/actions/deleteOfflineCamera';
import Table from '../../generic_components/Table/Table';
import Checkbox from '../../generic_components/Checkbox/Checkbox';
import Tooltip from '../../generic_components/Tooltip/Tooltip';
import Input from '../../generic_components/Input/Input';
// Import generic components
import Modal from '../../generic_components/Modal/Modal';

const Devices = ({ serverOfflineSince, devices, serverStatus, serverName, site, userBusinessRole }) => { 

    const [filteredDevices, setFilteredDevices] = useState(devices);
    const [searchTerm, setSearchTerm] = useState('');
        
    const user = localStorage.getItem('email');
    
    // const emailOptResponse = useSelector(state => state.optemailCamera);

    const dispatch = useDispatch();

    const deleteOfflineCameraResponse = useSelector(state => state.deleteOfflineCamera);   

    const handleSearchedCamera = (e) => {
        setSearchTerm(e.target.value);
    }

    const handleClearSearch = () => {
        setSearchTerm('');
    }

     // Apply filtering whenever devices or searchTerm changes
    useEffect(() => {
        if (searchTerm.trim() === '') {
            setFilteredDevices(devices);
        } else {
            const filtered = devices.filter(device => 
                device?.cameraName.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredDevices(filtered);
        }
    }, [devices, searchTerm]);

     useEffect(() => {
        const deletedCameraId = deleteOfflineCameraResponse.cameraID;
        const deletedCameraResponseCode = deleteOfflineCameraResponse.responseCode;
        
        if (serverName && deletedCameraResponseCode === 200 && deletedCameraId) {
        // remove the deleted camera from the devices list and update filteredDevices state
        const updatedDevices = devices.filter(device => device?.cameraId !== deletedCameraId);
        setFilteredDevices(updatedDevices);
        // fetch the updated devices list form the backend
          dispatch(listDevices(serverName, user, site));
        }
         
      }, [serverName, dispatch, user, deleteOfflineCameraResponse, devices, site]);

    useEffect(() => {
        setCheckOptOutEmail(
        devices.map((device) => ({
            cameraId: device.cameraId,
            emailOptOut: device.emailOptOut
        }))
        );
    }, [devices]);


    const [checkOptOutEmail, setCheckOptOutEmail] = useState(
        filteredDevices.map((device) => ({
            cameraId: device.cameraId,
            emailOptOut: device.emailOptOut
        }))
    );
    
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [selectedDeviceToDelete, setSelectedDeviceToDelete] = useState('');

    // Handle delete selected offline camera
    const handleDeleteOfflineCamera = (camera_id) => {
        dispatch(deleteOfflineCamera(camera_id, user));
        setShowConfirmation(false);
        dispatch(listDevices(serverName, user, site));    
    }

    // dispatch email opt-out submission to the backend
    const handleOptEmail = (e, serverName, cameraId, cameraName, confirmMsg) => {
        var confirmation = window.confirm(confirmMsg);

        if (confirmation) {
            setCheckOptOutEmail(prev => prev.map(cam => (
                cam.cameraId === cameraId 
                ?
                {...cam, emailOptOut:e.target.checked}
                :
                cam
            )));
            if (e.target.checked) {
            dispatch(optEmailCamera({optEmail: 0, user: user, serverName, cameraId, cameraName}));
            }
            else {
            dispatch(optEmailCamera({optEmail: 1, user: user, serverName, cameraId, cameraName}));
            }
        }
    };

    const utcStrToLocal = (utcTimestamp) => {
        const utcDate = new Date(utcTimestamp);

        // Get the local time components
        const localYear = utcDate.getFullYear();
        const localMonth = utcDate.getMonth() + 1; // Months are zero-based
        const localDay = utcDate.getDate();
        const localHours = utcDate.getHours();
        const localMinutes = utcDate.getMinutes();
        const localSeconds = utcDate.getSeconds();

        // Create a new Date object with the local time components
        const localDate = new Date(localYear, localMonth - 1, localDay, localHours, localMinutes, localSeconds);

        // Format the local time as needed
        const formattedLocalTime = localDate.toLocaleString();

        return formattedLocalTime
    }

    // Handle clicking the bin icon
    const handleBinClick = (device) => {
        setShowConfirmation(true);  
        setSelectedDeviceToDelete(device);       
    }

    // Handle hiding the popup
    const cancelDelete = () => {
        setShowConfirmation(false);
    };
    
    // Headers for devices table
    const devices_columns = useMemo(() => [
        { key: 'cameraName', label: 'Camera Name' },
        { key: 'serverName', label: 'Server Name' },
        { key: 'status', label: 'Status' },
        { key: 'offlineSince', label: 'Offline Since' },
        { key: 'muteNotifications', label: 'Mute Notifications' },
    ], []);

    const devices_data = filteredDevices.map((device, index) => {
        let toolTipText = "Mute email notifications";
        if (device?.emailOptOut) {
            toolTipText = "Unmute email notifications";
        }

        let confirmMsg = "Are you sure you want to mute notifications for this camera?";
        if (device?.emailOptOut) {
            confirmMsg = "Are you sure you want to unmute notifications for this camera?";
        }

        return {
            cameraName: device?.cameraName,
            serverName: device?.serverName,
            status: (
            <span style={{ color: serverStatus === 'Offline' || device?.cameraStatus === 'Offline' ? '#C82333' : '#22BE63', fontWeight: '600' }}>
                {serverStatus === 'Offline' ? 'Offline' : device?.cameraStatus}
            </span>
            ),
            offlineSince: serverOfflineSince !== '-' 
            ? serverOfflineSince 
            : (device?.cameraOfflineSince === 'N/A' ? 'N/A' : utcStrToLocal(device?.cameraOfflineSince)),
            muteNotifications: (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Tooltip content={toolTipText} placement="top" tooltipStyle={{padding: '0.4rem'}}>
                    <img 
                        alt='Opt-Out Email Notifications'
                        style={{ height: '1rem', marginRight: '0.5rem', marginTop: '-0.4rem' }}
                        src={Mute}
                    />
                </Tooltip>

                <Checkbox 
                    // checked={device?.emailOptOut ? true : false}
                    checked={checkOptOutEmail.find(cam => cam.cameraId === device.cameraId).emailOptOut}
                    onChange={(e) => handleOptEmail(e, device?.serverName, device?.cameraId, device?.cameraName, confirmMsg)}
                    checkboxStyle={{width: '0.7rem', height: '0.7rem'}}
                />

                {(canAccess('delete-offline-cameras', userBusinessRole) && device?.cameraStatus === 'Offline') && (
                <img 
                    alt='delete'
                    style={{ marginLeft: '9px', height: '13px', width: '13px', cursor: 'pointer' }}
                    src={bin}
                    onClick={() => handleBinClick(device)}
                />
                )}
            </div>
            ),
        };
    });

     
  return (
    <div className='table-container-device' style={{ fontSize: '.85em' }}>
        {/* add a search bar here to filter the devices given camera name */}
        <div className='search-container' style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <Input 
                className='search-box'
                type='text'
                placeholder='Search camera name...'
                value={searchTerm}
                onChange={ handleSearchedCamera }
                size='sm'
                style={{ flex: 1 }}
            />
            {searchTerm && (
               <Tooltip content={"Clear search"} placement="right">
                 <Button
                    onClick={handleClearSearch}
                    variant="ghost" 
                    size="small"
                    aria-label="Clear search"
                    style={{  marginBottom: '1em' }}
                    >
                    X
                </Button>
                </Tooltip>
            )}
        </div>

        <Table           
            columns={devices_columns}
            data={devices_data}
        />

        <Modal size='sm' show={showConfirmation} onHide={cancelDelete}>
            <Modal.Header closeButton>
                <Modal.Title>
                Confirm Delete
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ marginBottom: '1em' }}>
                Are you sure you want to delete the following camera?
                <div>{selectedDeviceToDelete.cameraName}</div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button variant="danger" size="small" onClick={() => handleDeleteOfflineCamera(selectedDeviceToDelete.cameraId)}>Delete</Button>
                <Button variant="ghost" size="small" onClick={cancelDelete}>Cancel</Button>
                </div>
            </Modal.Body>
        </Modal>
    </div>
  )
}

export default Devices